import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696822e0c9f2cb0014a3d5ba/ai_style_gallery/src/app/homepage/components/HomepageInteractive.tsx");
